import cx from 'clsx';
import * as React from 'react';

import { ArrowLeft, ArrowRight } from '@/components/icons';

import styles from './Slider.module.scss';

interface ArrowSliderProps {
  element: any;
  scrollValue: number;
  disableValue: {
    min?: number;
    max?: number;
  };
}

const ArrowSlider: React.FC<ArrowSliderProps> = ({
  element,
  scrollValue,
  disableValue,
}) => {
  const direction = scrollValue < 0 ? 'left' : 'right';
  const [elementScroll, setElementScroll] = React.useState(0);
  let shouldBeDisabled = elementScroll <= (disableValue.min || 0);
  if (disableValue.max) {
    shouldBeDisabled = elementScroll >= disableValue.max;
  }

  React.useEffect(() => {
    const currElem = element.current;
    const handleScroll = () => {
      setElementScroll(element.current.scrollLeft);
    };
    currElem && currElem.addEventListener('scroll', handleScroll);
    return () => {
      currElem && currElem.removeEventListener('scroll', handleScroll);
    };
  });

  const sideScroll = () => {
    let scrollAmount = 0;
    const slideTimer = setInterval(() => {
      element.current.scrollLeft += scrollValue;
      setElementScroll(element.current.scrollLeft);
      scrollAmount += Math.abs(scrollValue);
      if (scrollAmount >= 100) {
        clearInterval(slideTimer);
      }
    }, 100);
  };

  return (
    <span
      onClick={sideScroll}
      data-testid="slider-arrow"
      className={cx(
        styles.arrow,
        {
          [styles.right]: direction === 'right',
          [styles.left]: direction === 'left',
        },
        shouldBeDisabled && styles.disabled
      )}
    >
      {direction === 'left' ? (
        <ArrowLeft className={styles.sliderArrow} />
      ) : (
        <ArrowRight className={styles.sliderArrow} />
      )}
    </span>
  );
};

export default ArrowSlider;
